export const environment = {
  ENV: 'DEV',
  API_URL: 'https://api.dream-talent-dev.tma-swerp.com',
  APP_NAME: 'TMA',
  LOGO: '/assets/images/Logo-2.svg',
  IDLE_TIMEOUT: 12 * 60 * 60 * 1000, // 12 hours,
  FIREBASE_CONFIG: {
    apiKey: "AIzaSyD5hS2n0TthcLh3rvjTJ9ieiJfBzebf-ss",
    authDomain: "drt-noti.firebaseapp.com",
    projectId: "drt-noti",
    storageBucket: "drt-noti.firebasestorage.app",
    messagingSenderId: "267624769338",
    appId: "1:267624769338:web:35c44ca5d6268150299203",
    measurementId: "G-BH642C3356"
  },
  FCM_VAPID_KEY: "BP2ww094g17Sj9g50yM_YfquIm3ZMqfj-uShllNgrIrCrej5MBdhyRnDqCiGfrPbqcuWDN4GCayjl2oWlSC3y6o"
};
